import axiosIns from 'utils/axios'

let epmcore = 'EPM-CORE-SERVICE'


// 判断是否有退回日报权限
export function hasReturnBackPermission(id) {
  return axiosIns({
    url: `/api/pc/daily/hasReturnBackPermission/${id}`,
    method: 'get',
    owner: epmcore
  })
}

// 获取当天工作台完成的需求
export function getCompleteDemand(params) {
  return axiosIns({
    url: `/api/pc/daily/getDemandByDate`,
    method: 'get',
    owner: epmcore,
    params
  })
}

export function dictPage(params) {
  return axiosIns({
    url: `/api/pc/companyDict/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

/**
 * 查询项目列表
 */
export function listProject() {
  return axiosIns({
    url: `/api/pc/project/listProject`,
    owner: epmcore,
    method: 'get',
  })
}

export function getProject(params) {
  return axiosIns({
    url: `/api/pc/project/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}


// 项目版本分页
export function getVersionPage(params) {
  return axiosIns({
    url: `/api/pc/projectVersion/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function deleteDaily(dailyId){
  return axiosIns({
    url:`/api/pc/daily/delete/${dailyId}`,
    method:'delete'
  })
}

// 获取需求列表
// export function getDemandList (projectVersionId) {
//   return axiosIns({
//     url: `/api/pc/demand/list/${projectVersionId}`,
//     owner: epmcore,
//     method: 'get'
//   })
// }

// function formatTree (e) {
//   let tree = []
//   e.forEach((item) => {
//     if (!item.mpttVOList) {
//       tree.push({
//         label: item.data.name,
//         key: item.id,
//         rootId: item.rootId,
//         demandModuleId: item.data.demandModuleId || '',
//         children: []
//       })
//     } else {
//       tree.push({
//         label: item.data.name,
//         key: item.id + '-',
//         rootId: item.rootId,
//         demandModuleId: item.data.demandModuleId || '',
//         children: formatTree(item.mpttVOList)
//       })
//     }
//   })
//   return tree
// }

function formatTree(e) {
  let tree = []
  e.forEach((item) => {
    if (item.mpttVOList && !item.data.demandVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: formatTree(item.mpttVOList),
        disabled: checkDisabled(!item.demandModuleId)
      })
    } else if (item.mpttVOList && item.data.demandVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: formatTree(item.mpttVOList).concat(formatDemandTree(item.data.demandVOList)),
        disabled: checkDisabled(!item.demandModuleId)
      })
    } else if (!item.mpttVOList && !item.data.demandVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: [],
        disabled: checkDisabled(!item.demandModuleId)
      })
    } else if (!item.mpttVOList && item.data.demandVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: formatDemandTree(item.data.demandVOList),
        disabled: checkDisabled(!item.demandModuleId)
      })
    }
  })
  return tree
}

function formatDemandTree(e) {
  let list = []
  e.forEach((item) => {
    list.push(Object.assign(item, {
      label: item.name,
      key: item.id,
      rootId: item.rootId,
      demandModuleId: item.demandModuleId || '',
      children: [],
      disabled: checkDisabled(!item.demandModuleId)
    }))
  })
  return list
}

function checkDisabled(e) {
  // if (e) return true
  // else return false
  return false
}

// 获取需求列表
export function getDemandList(id) {
  return axiosIns({
    url: `/api/pc/demand/list/${id}`,
    owner: epmcore,
    method: 'get'
  }).then(res => {
    return Promise.resolve(formatTree(res.data))
  }).catch(err => {
    return Promise.reject(err)
  })
}

// 新增日报
export function addDaily(data) {
  return axiosIns({
    url: `/api/pc/daily/add`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
// 重新提交日报
export function resubmitDaily(data) {
  return axiosIns({
    url: `/api/pc/daily/resubmit`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}


// -----------周报

export function getLastWeekly(data) {
  return axiosIns({
    url: `/api/pc/weekly/getLastWeekly`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}

// 新增周报
export function addWeekly(data) {
  return axiosIns({
    url: `/api/pc/weekly/add`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
let textIndent = 2;
//日常反馈
export function getFeedbackData(arr) {
  if (arr) {
    return `<strong>• 任务日常反馈</strong><br/><div style="text-indent:${textIndent}em;"><span>`
      + arr.replace(/\n/g, `<br/></span></div><div style="text-indent:${textIndent}em;"><span>`) + '<br/></span></div>';
  } else {
    return `<strong>• 任务日常反馈</strong><br/><div style="text-indent:${textIndent}em;"><span>无<br/></span></div>`
  }
}

// 任务
export function getTaskData(arr) {
  let strTask = ''
  if (arr) {
    strTask = strTask + '<strong>• 任务</strong><br/>'
    arr.forEach((item) => {
      strTask += `<div style="text-indent:${textIndent}em; font-weight: 500;"><span>【` + item.projectName + '】- ' + item.type + '（' + item.costTime + 'h）<br/></span></div>' +
        `<div style="text-indent:${textIndent}em;"><span>`
        + (item.content ? item.content.replace(/\n/g, `<br/></span></div><div style="text-indent:${textIndent}em;"><span>`) : '')
        + '<br/></span></div>'
    })
  }
  return strTask
}
// 加班
export function overTimeData(arr) {
  let strTask = ''
  if (arr) {
    strTask = strTask + '<strong>• 加班</strong><br/>'
    arr.forEach((item, index) => {
      strTask = strTask + `<div style="text-indent:${textIndent}em;">`  + (index + 1) + '. ' + item.projectName + ' 时长：' + item.costTime + '小时' + '</div><br/>'
    })
  }
  return strTask
}
// 请假
export function dailyLeaveVO(arr) {
  let strTask = ''
  if (arr) {
    if (arr.leaveTotalTime) {
      strTask = strTask + '<strong>• 请假</strong><br/>'
      //   arr.forEach((item) => {
      strTask = strTask + `<div style="text-indent:${textIndent}em;"><span>` + arr.leaveType + '（' + arr.leaveTotalTime + '小时）' + '<br/></span></div>'
      //   })
    }
  }
  return strTask
}
// 需求
export function getDemandData(arr) {
  let strDemand = ''
  if (arr) {
    let textIndent = 2;
    strDemand += '<strong>• 需求</strong><br/>'
    arr.forEach((item, index) => {
      item.dailyDemandProjectVersionVOList.forEach((item2) => {
        strDemand = strDemand + `<div style="text-indent:${textIndent}em; font-weight: 500;"><span>【` + item.project + '(' + item2.projectVersion + ')】<br/></span></div>'
        item2.dailyDemandVOList.forEach((item3, index) => {
          strDemand = strDemand + `<div style="text-indent:${textIndent}em;">` + (index + 1) + '. <strong>[' + item3.type + ']</strong><br/></div>'
            + `<div style="text-indent:${textIndent + 2}em;"><span>` + item3.demandName + '(' + item3.costTime + 'h);<br/></span></div>'
        })
      })
    })
  }
  return strDemand
}

export function exportDailyList(data) {
  return axiosIns({
    url: '/api/pc/weekly/export',
    owner: epmcore,
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

export function getTime(s, e) {
  let long = (new Date(e).getTime() - new Date(s).getTime()) / 1000
  let day = Math.floor(long / (60 * 60 * 24))
  let hour = Math.floor((long - (day * 60 * 60 * 24)) / (60 * 60))
  let minues = Math.ceil((long - (day * 60 * 60 * 24) - (hour * 60 * 60)) / 60)

  let h = Math.floor(long / (60 * 60) * 100) / 100
  return h + 'h'
}
export function getMeetingData(arr) {
  let strMeeting = ''
  if (arr && arr.length > 0) {
    strMeeting = strMeeting + '<strong>• 会议</strong><br \>'
    arr.forEach((item, index) => {
      strMeeting = strMeeting + (index + 1) + '.<strong>[' + (item.type === 1 ? '售前会议' : '项目会议') + ']</strong>' + item.topic +
        '(' + getTime(item.startTime, item.endTime) + ');<br \>'
    })
  } else {
    strMeeting = strMeeting + '<strong>• 会议</strong><br \>无<br \>'
  }
  return strMeeting
}

//日报
export function getWeekData(arr, employeeId, employeeName, meetingList) {
  // debugger;
  let weekobj = []
  let strWeek = '未提交'
  let demand = ''
  let task = ''
  let dailyLeave = ''
  let dailyOverTimeVO = ''
  // let taskOver = ''
  let meeting = ''
  let feedback = ''
  if (arr) {
    demand = getDemandData(arr.dailyDemandProjectVOList)
    task = getTaskData(arr.dailyTaskVOList)
    dailyLeave = dailyLeaveVO(arr.dailyLeaveVO)
    dailyOverTimeVO = overTimeData(arr.dailyOverTimeVOList)
    // console.log('arr.dailyLeaveVOarr.dailyLeaveVO', arr.dailyLeaveVO)
    if (meetingList && meetingList.meetingVOList) {
      meeting = getMeetingData(meetingList.meetingVOList)
    }
    feedback = getFeedbackData(arr.feedback)
    strWeek = demand + task + dailyOverTimeVO + dailyLeave + feedback
    if (strWeek) {
      strWeek = demand + task + dailyOverTimeVO + dailyLeave + feedback
    }
    weekobj.push({
      id: arr.id,
      createTime: arr.createTime,
      status: arr.status,
      text: strWeek,
      returnReason: arr.returnReason,
      employeeId: arr.employeeId,
      employeeText: '<strong>' + employeeName + '</strong><br \>' + strWeek,
      type: 1 // 1 日报 2 周报
    })
  } else {
    weekobj.push({
      text: strWeek,
      employeeId: employeeId
    })
  }
  return weekobj
}

export function getData(arr) {
  console.log(arr);
  let temp = []
  let week = []
  let plan = []
  let sumUp = []
  var vars = {}; //批量定义
  arr.forEach((item, index) => {
    temp.push({
      employeeName: item.employeeName,
      sumUp: '本周总结'
    })
    // 日报
    if (item.dailySortVOList) {
      for (let i = 0; i < item.dailySortVOList.length; i++) {
        let varName = i + ""; //动态定义变量名
        vars[varName] = getWeekData(item.dailySortVOList[i], item.employeeId, item.employeeName, item.dailyMeetingVOList[i]); //动态赋值
      }
      // console.log('mmmmmm',vars)
      week.push(vars)
    }
    // 本周计划 需求和任务
    let planDemand = ''
    let planTask = '<strong>• 任务</strong><br \>'
    let strTask = ''
    if (item.nextWeekDemandProjectVOList) {
      item.nextWeekDemandProjectVOList.forEach((item2) => {
        item2.nextWeekDemandProjectVersionVOList.forEach((item3, index3) => {
          planDemand = planDemand + '<strong>• ' + item2.project + '(' + item3.projectVersion + ')</strong><br \>'
          item3.nextWeekDemandVOList.forEach((item4, index4) => {
            planDemand = planDemand +
              (index4 + 1) + '.<strong>[' + item4.type + ']</strong>' + item4.demandName + '(' + item4.planProgressRate + '%);<br \>'
          })
        })
      })
    }
    if (item.nextWeekTaskVOList && item.nextWeekTaskVOList.length > 0) {
      item.nextWeekTaskVOList.forEach((item3) => {
        strTask = strTask + item3.sort + '.<strong>[' + item3.type + ']</strong>' + (item3.content ? item3.content : '') + ';<br \>'
      })
    } else {
      planTask = planTask + '无<br \>'
    }
    if (planDemand === '' && strTask === '') {
      planTask = ''
    }
    let planobj = []
    planobj.push({
      text: planDemand + planTask + strTask,
      employeeText: '<strong>' + item.employeeName + '</strong><br \>' + planDemand + planTask + strTask,
    })
    plan.push({
      plan: planobj
    })
    // 本周总结 需求和任务
    let sumUpobj = []
    let sumUpDemand = ''
    let sumUpTask = ''
    let strUpTask = '<strong>• 任务</strong><br \>'
    if (item.weekDemandProjectVOList) {
      item.weekDemandProjectVOList.forEach((item2) => {
        item2.weekDemandProjectVersionVOList.forEach((item3, index3) => {
          sumUpDemand = sumUpDemand + '<strong>• ' + item2.project + '(' + item3.projectVersion + ')</strong><br \>'
          item3.weekDemandVOList.forEach((item4, index4) => {
            // console.log('ooooo', item3.weekDemandVOList)
            // if (item4.reachGoalFlag !== null) { // 是否达标 已提交
            sumUpDemand = sumUpDemand +
              (index4 + 1) + '.<strong>[' + item4.type + ']</strong>' + item4.demandName + '(' + item4.planProgressRate + '%);<br \>'
            if (item4.reachGoalFlag === 1) {
              sumUpDemand = sumUpDemand + '(已达标)<br \>'
            } else {
              sumUpDemand = sumUpDemand + '<span style="color:red">(未达标-'
              if (item4.overdueInstructions) {
                sumUpDemand = sumUpDemand + (item4.overdueInstructions ? item4.overdueInstructions : '已修改上周周报内容') + ')</span><br \>'
              } else {
                sumUpDemand = sumUpDemand + '已修改上周周报内容' + ')</span><br \>'
              }
              // console.log('uuuuu', item4.overdueInstructions)
            }
            // } else { // 为null 未提交
            //   sumUpDemand = ""
            // }
          })
        })
      })
    }
    let strOverTask = '<strong>• 计划外</strong><br \>'
    let sumUpOverTask = ''

    if (item.extraWeekDemandProjectVOList && item.extraWeekDemandProjectVOList.length > 0) { //计划外
      item.extraWeekDemandProjectVOList.forEach(i => {
        i.nextWeekDemandProjectVersionVOList.forEach((i2, index2) => {
          sumUpOverTask = sumUpOverTask + '<strong>• ' + i.project + '(' + i2.projectVersion + ')</strong><br \>'
          i2.nextWeekDemandVOList.forEach((i3, index3) => {
            sumUpOverTask = sumUpOverTask + (index3 + 1) + '.<strong>[' + i3.type + ']</strong>' + i3.demandName + '(' + i3.planProgressRate + '%);<br \>'
          })
        })
      })
    } else {
      sumUpOverTask = sumUpOverTask + '无<br />'
    }

    if (item.weekTaskVOList && item.weekTaskVOList.length > 0) { // 任务
      item.weekTaskVOList.forEach((item3) => {
        strUpTask = strUpTask + item3.sort + '.<strong>[' + item3.type + ']</strong>' + (item3.content ? item3.content : '') +
          (item3.reachGoalFlag === 1 ? '(已达标)' : ('<span style="color:red">(未达标-' + (item3.overdueInstructions ? item3.overdueInstructions : '已修改上周周报内容') + ')</span>')) + ';<br \>'
      })
    } else {
      strUpTask = strUpTask + '无<br \>'
    }


    let strFeedback = '' // 本周反馈
    if (item.feedback) {
      strFeedback = '<strong>• 周报反馈</strong><br \>' + item.feedback.replace(/\n/g, '<br />')
    } else {
      strFeedback = '<strong>• 周报反馈</strong><br \>无'
    }
    // if (sumUpDemand === "" && strUpTask === '' && strFeedback === '') { // 未提交
    if (!item.startReportTime) { // 未提交
      sumUpobj.push({
        text: "未提交",
        employeeId: item.employeeId
      })
    } else {
      sumUpobj.push({
        id: item.id,
        lastWeeklyId: item.lastWeeklyId,
        createTime: item.createTime,
        status: item.status,
        text: sumUpDemand + strOverTask + sumUpOverTask + sumUpTask + strUpTask + strFeedback,
        returnReason: item.returnReason,
        employeeId: item.employeeId,
        employeeText: '<strong>' + item.employeeName + '</strong><br \>' + sumUpDemand + strOverTask + sumUpOverTask + sumUpTask + strUpTask + strFeedback,
        type: 2 // 1 日报 2 周报
      })
    }
    sumUp.push({
      sumUp: sumUpobj
    })

    Object.assign(temp[index], plan[index]);
    Object.assign(temp[index], week[index]);
    Object.assign(temp[index], sumUp[index]);
  })
  return temp
}


// 周报
export function getWeeklyPage(data) {
  return axiosIns({
    url: `/api/pc/weekly/page`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}

// 退回日报
export function returnBackDaily(data) {
  return axiosIns({
    url: `/api/pc/daily/returnBack`,
    owner: epmcore,
    method: 'put',
    data
  })
}

// 退回周报
export function returnBackWeekly(data) {
  return axiosIns({
    url: `/api/pc/weekly/returnBack`,
    owner: epmcore,
    method: 'put',
    data
  })
}

// 根据Id获取日报信息
export function getDaily(id) {
  return axiosIns({
    url: `/api/pc/daily/getDaily/${id}`,
    owner: epmcore,
    method: 'get'
  })
}

// 根据日期获取日报
export function getDailyByDate(params) {
  return axiosIns({
    url: `/api/pc/daily/getDailyByDate`,
    owner: epmcore,
    method: 'get',
    params
  })
}

// 重新提交周报时获取周报信息
export function getResubmitWeekly(data) {
  return axiosIns({
    url: `/api/pc/weekly/getResubmitWeekly`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}

// 重新提交周报
export function resubmitWeekly(data) {
  return axiosIns({
    url: `/api/pc/weekly/resubmit`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
// 分页查询会议
export function getPageMeeting(params) {
  return axiosIns({
    url: `/api/pc/meeting/pageMeeting`,
    owner: epmcore,
    method: 'get',
    params
  }).then(res => {
    // let meeting = []
    // res.data.records.forEach((item) => {
    //   meeting.push({
    //     type:item.type,
    //     projectName:item.projectVO.name+'('+item+')',
    //     topic:'',
    //     costTime:''
    //   })
    // })
    return Promise.resolve(res)
  })
}



// WEBPACK FOOTER //
// ./src/views/report-manage/reportAPI.js